export enum UnitCode {
  'Surubim' = 23,
  'Bodocó' = 24,
  'Buíque' = 27,
  'Araripina' = 28,
  'Triunfo' = 50,
  'Belo Jardim' = 59,
  'Arcoverde' = 71,
  'Garanhuns Turismo Lazer' = 72,
  'Garanhuns' = 73,
  'Campos' = 84,
  'Piedade' = 149,
  'Santo Amaro' = 186,
  'Casa Amarela' = 188,
  'Santa Rita' = 193,
  'Caruaru' = 243,
  'Petrolina' = 269,
  'Goiana' = 409,
  'Pesqueira' = 457,
  'Serra Talhada' = 641,
  'Floresta' = 642,
  'São Lourenço' = 913
}
